module.exports = __webpack_public_path__ + "media/images/page/top/top_img_03-72e300b04a4025fb04dd6e1082b48012.png";